import { render, staticRenderFns } from "./childOutbound.vue?vue&type=template&id=827be370"
import script from "./childOutbound.vue?vue&type=script&lang=js"
export * from "./childOutbound.vue?vue&type=script&lang=js"
import style0 from "./childOutbound.vue?vue&type=style&index=0&id=827be370&lang=scss"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('827be370')) {
      api.createRecord('827be370', component.options)
    } else {
      api.reload('827be370', component.options)
    }
    module.hot.accept("./childOutbound.vue?vue&type=template&id=827be370", function () {
      api.rerender('827be370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventorySystemManagement/outbound/childOutbound.vue"
export default component.exports